import type { AppRouteRecordRaw } from '@/router/types'

export const clueManageRoutes: AppRouteRecordRaw[] = [
  {
    path: 'clueManage',
    name: 'ClueManage',
    component: () => import('@/views/clueManage/index.vue'),
    meta: { title: '线索管理', keepAlive: true }
  },
  {
    path: 'clueDetail',
    name: 'ClueDetail',
    component: () => import('@/views/clueManage/clueDetail/index.vue'),
    meta: { title: '线索详情' }
  }
]
